import React from "react"
import { FaUser } from "react-icons/fa"
import tw from "tailwind-styled-components"
import { MdOutlineChevronRight } from "react-icons/md"
import Tooltip from "../../Tooltip"

function SummaryCard({ summaryData, onClick, selectedKey = null }) {
    const summary = [
        {
            amount: summaryData?.totalVacantBeds || 0,
            label: "Total Vacancy",
            color: "text-black",
            subTitle: summaryData?.occupancyPercentage || 0,
            subLabel: "Occupancy %",
            icon: <FaUser size={20} className="text-blue-400" />,
            filter: null,
        },
        {
            amount: summaryData?.maleVacancy || 0,
            label: "Male",
            color: "text-black",
            icon: <FaUser size={20} className="text-teal-400" />,
            filter: {
                type: "gender",
                value: 1,
            },
        },
        {
            amount: summaryData?.femaleVacancy || 0,
            label: "Female",
            color: "text-black",
            icon: <FaUser size={20} className="text-orange-400" />,
            filter: {
                type: "gender",
                value: 2,
            },
        },
        {
            amount: summaryData?.unisexVacancy || 0,
            label: "Co-Living",
            color: "text-black",
            icon: <FaUser size={20} className="text-orange-400" />,
            filter: {
                type: "gender",
                value: 3,
            },
        },
        {
            amount: summaryData?.singleSharing || 0,
            label: "Single Sharing",
            color: "text-black",
            // subLabel: `Tentative Refund`,
            // subTitle: (summaryData?.movingOutRefund || '0'),
            icon: <FaUser size={20} className="text-rose-400" />,
            filter: {
                type: "sharing",
                value: 1,
            },
        },
        {
            amount: summaryData?.doubleSharing || 0,
            label: "Double Sharing",
            color: "text-black",
            // subLabel: `Tentative Refund`,
            // subTitle: (summaryData?.movingOutRefund || '0'),
            icon: <FaUser size={20} className="text-rose-400" />,
            filter: {
                type: "sharing",
                value: 2,
            },
        },
        {
            amount: summaryData?.tripleSharing || 0,
            label: "Triple Sharing",
            color: "text-black",
            icon: <FaUser size={20} className="text-rose-400" />,
            filter: {
                type: "sharing",
                value: 3,
            },
        },
        {
            amount: summaryData?.fourSharing || 0,
            label: "3+ Sharing",
            color: "text-black",
            icon: <FaUser size={20} className="text-rose-400" />,
            filter: {
                type: "sharing",
                value: "3+",
            },
        },

    ];



    return (
        <Wrapper>
            <ScrollCard style={{ scrollBehavior: "smooth" }}>
                {summary.map((item) => {
                    //const selected = selectedKey?.type === item.filter?.type && selectedKey?.value === item.filter?.value;
                    const selected =
                        item.filter !== null &&
                        selectedKey?.type === item.filter?.type &&
                        selectedKey?.value === item.filter?.value;
                    return (
                        <Card
                            key={item.label}
                            $selected={selected}
                            //onClick={() => onClick(item.filter)}
                            onClick={() => {
                                if (selected) {
                                    onClick(null);
                                } else {
                                    onClick(item.filter);
                                }
                            }}
                        >
                            <ValueRow>
                                <Value className={item.color}>
                                    {item.amount}
                                    {item.subTitle &&
                                        <Tooltip label={item.subLabel}>
                                            <span className="ml-1 mt-auto text-sm text-gray-600 align-middle mb-1">{"(" + item.subTitle + "%)"}</span>
                                        </Tooltip>
                                    }
                                </Value>
                            </ValueRow>
                            <Label>
                                {item.label}
                                <ArrowWrap className="arrow">
                                    <Chevron />
                                </ArrowWrap>
                            </Label>
                        </Card>
                    )
                })}
            </ScrollCard>
        </Wrapper>
    )
}

// const Wrapper = tw.div`w-full`
const ScrollCard = tw.div`w-full overflow-x-auto flex space-x-4 py-1`
// const Card = tw.div`min-w-[200px] p-3 rounded-md bg-white shadow-md cursor-pointer hover:shadow-sm hover:shadow-primary-color ${({ $selected }) =>
//     $selected ? "shadow-sm shadow-primary-color" : ""}`
// const Label = tw.div`text-gray-500 text-sm break-words flex items-center w-full mt-2 justify-between whitespace-normal`
// // const Value = tw.p`text-xl sm:text-2xl font-bold`
// const Value = tw.p`
//   text-xl sm:text-2xl font-bold  
//   ${({ color }) =>
//         color}
// `;

const Wrapper = tw.div`
  w-full
`;

const Card = tw.div`
  group min-w-[200px]
  rounded-lg bg-white
  p-4 
  cursor-pointer
  border border-gray-100
  shadow-sm
  transition-all duration-200
  hover:shadow-md hover:border-gray-200
  ${({ $selected }) =>
        $selected
            ? "border-primary-color shadow-md"
            : ""}
`;


const ValueRow = tw.div`
  flex items-baseline gap-1
`;

const Value = tw.div`
  text-xl font-semibold text-gray-900
`;

const Label = tw.div`
  flex  mt-2 text-sm text-gray-500 items-center justify-between
`;

const ArrowWrap = tw.div`
  flex items-center
  text-gray-300
  transition-all duration-200
`;

const Chevron = tw(MdOutlineChevronRight)`
  text-lg
  transform translate-x-0
  opacity-60
  group-hover:opacity-100
  group-hover:text-gray-500
  group-hover:translate-x-1
`;

export default SummaryCard
